import React, { useEffect, useState } from 'react';
import { Box, Flex, Text, Badge, VStack, HStack, Alert, AlertIcon } from '@chakra-ui/react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { careerApi } from './careerApi';

export default function MyApplications() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const justApplied = params.get('applied') === '1';

  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  async function load() {
    setLoading(true);
    try {
      const res = await careerApi.myApplications();
      setApps(res?.applications || []);
    } catch (e) {
      if (String(e.message).match(/auth|session/i)) nav('/login?redirect=/my-applications');
    }
    setLoading(false);
  }

  return (
    <Box>
      <Text fontSize="24px" fontWeight="800" color="#1A202C" mb="6px">My applications</Text>
      <Text fontSize="13px" color="#718096" mb="20px">Track where you are in the process for each role you've applied to.</Text>

      {justApplied && <Alert status="success" borderRadius="10px" mb="16px"><AlertIcon />Application submitted. You'll get an email confirmation shortly.</Alert>}

      {loading && <Text color="#A0AEC0">Loading…</Text>}
      {!loading && apps.length === 0 && (
        <Box bg="white" border="1px solid #E2E8F0" borderRadius="12px" p="60px" textAlign="center" color="#A0AEC0">
          <Text mb="12px">You haven't applied to any roles yet.</Text>
          <Text as={Link} to="/" color="#3730A3" fontWeight="600">Browse open positions →</Text>
        </Box>
      )}

      <VStack spacing="12px" align="stretch">
        {apps.map(a => {
          const stage = a.CurrentStage || {};
          return (
            <Box key={a.id} bg="white" border="1px solid #E2E8F0" borderRadius="12px" p="20px 24px">
              <Flex justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap="10px">
                <Box>
                  <Text fontSize="15px" fontWeight="700" color="#1A202C">{a.TalentRequisition?.title || a.TalentRequisition?.req_no}</Text>
                  <Text fontSize="12px" color="#718096">Ref: {a.TalentRequisition?.req_no}</Text>
                </Box>
                <Badge fontSize="11px" px="10px" py="4px" borderRadius="6px" textTransform="none"
                  bg={stage.color ? `${stage.color}22` : '#EDF2F7'} color={stage.color || '#4A5568'} border={`1px solid ${stage.color || '#E2E8F0'}`}>
                  {stage.name || 'New Applicant'}
                </Badge>
              </Flex>
              <HStack spacing="16px" mt="10px" fontSize="12px" color="#718096">
                <Text>Applied {new Date(a.applied_at).toLocaleDateString()}</Text>
                {a.match_score != null && <Text>Match score: {Math.round(a.match_score)}%</Text>}
              </HStack>
            </Box>
          );
        })}
      </VStack>
    </Box>
  );
}
